import { useEffect, useState } from "react";
import Hero from "@/sections/Hero";
import Welcome from "@/sections/Welcome";
import Arc from "@/sections/Arc";
import MenuHighlights from "@/sections/MenuHighlights";
import Events from "@/sections/Events";
import Gallery from "@/sections/Gallery";
import Reserve from "@/sections/Reserve";
import { VLogo } from "@/components/VLogo";
import { useLang } from "@/i18n/LanguageContext";

const Intro = () => {
  const [done, setDone] = useState(() => !!sessionStorage.getItem("vammos-intro"));
  useEffect(() => {
    if (!done) {
      const timer = setTimeout(() => {
        sessionStorage.setItem("vammos-intro", "1");
        setDone(true);
      }, 2900);
      return () => clearTimeout(timer);
    }
  }, [done]);
  if (done) return null;
  return (
    <div className="intro" data-testid="intro-overlay">
      <div className="intro__inner">
        <VLogo height={220} className="intro__logo" />
      </div>
    </div>
  );
};

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div className="marquee" data-testid="marquee">
      <div className="marquee__track">
        {items.map((m, i) => (
          <span key={`${m}-${i}`} className="marquee__item">
            {m} <span className="marquee__dot">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default function Home() {
  return (
    <main data-testid="home-page">
      <Intro />
      <Hero />
      <Marquee />
      <Welcome />
      <MenuHighlights />
      <Arc />
      <Events />
      <Gallery />
      <Reserve />
    </main>
  );
}
